import React, { useState } from 'react';
import {KpiInfo, KpiProps} from "../../../../../types/types";
import "./ScriptConfigurationStep.css"
import {popNotification} from "../../notification/notificationUtils";
import {InfoCircle} from "tabler-icons-react";
import {StringUtils} from "../../../../../utils/stringUtils";
import { ScriptModal } from './modal/ScriptModal';


export const findQueryResultObject = (kpiInfo: KpiInfo) => {
    const emptyObject = {};
    const queryObject: Record<string, any> = {}
    kpiInfo.configuration.queries.forEach(query => {
        queryObject[query.name] = [emptyObject, emptyObject]
    });
    return  JSON.stringify(queryObject);
}

export function ScriptConfigurationStep(props: KpiProps) {


    const hasValidationErrors = props.validationErrors?.length > 0;

    if (hasValidationErrors) {
        popNotification("Alert", props.validationErrors.map(er => er.message).join(", "), "red",
            <InfoCircle/>);
    }

    const comments = `/**
 * Method for finding out the kpi from the query results. This function will execute against each user.
 * Can return array of kpis or single kpi as object. Empty array will be ignored.
 * Each object should have a property named value which will treat as the kpi.
 * Optional status will be stored as status of the kpi in the backend.
 * Other properties will be treated as extended attributes.
 * @param ${findQueryResultObject(props.kpiInfo)} queryResults - query name and it's results as key value pairs
 * @returns {{value: string|number, status?:string, otherProps: string...} | {value: string|number, status?:string, otherProps: string...}[]}
 */
`


    const script = !StringUtils.isEmpty(props.kpiInfo.statusEvaluator) ? props.kpiInfo.statusEvaluator : `// function evaluate(queryResults) {
//     find kpi from the queryResults
//     return {
//         "value": "find Kpi Value From QueryResult",
//         "status": "Find status from query result",
//         "otherProp": "you can put other properties"
//     }
// }`;
    const [opened, setOpened] = useState(false);
    const openScriptEditor = () =>{
        setOpened(true);
    }

    const value = comments + script

    return (
        <>
            <div className="wizard-content-card" onClick={openScriptEditor} style={{width:"100%", height:"20rem", overflow: "auto"}}>
                <pre style={{whiteSpace: "pre-wrap", padding: "3rem", paddingTop: "0rem"}}>
                {value}
                </pre>
            </div>
            <ScriptModal {...props} opened={opened} setOpened={setOpened} value={value}/>
            
        </>
    )
}
